import { render, staticRenderFns } from "./beijingSingle.vue?vue&type=template&id=483d89cb&scoped=true&"
import script from "./beijingSingle.vue?vue&type=script&lang=js&"
export * from "./beijingSingle.vue?vue&type=script&lang=js&"
import style0 from "./beijingSingle.vue?vue&type=style&index=0&id=483d89cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483d89cb",
  null
  
)

export default component.exports